import React from 'react';
import { BackButton } from '../../../components/BackButton/BackButton';
import { TranslationUtils } from '../../../utils';
import { useSelector } from 'react-redux';
import { StoreState } from '../../../types/store.type';
import { RequiredActions } from 'guest-data-types-ts-lib';
import { Loading } from '../../../components/Loading/Loading';
import './PalRentalAgreement.scss';
import { getHouseRuleIconByKey } from '../../../components/RentalAgreement/RentalAgreementHelper';
import { IconAlertCircle, IconCheckSquare } from '../../../assets/icons';
import * as _ from 'lodash';
import { QuestionPanel } from './components';

export const PalRentalAgreement: React.FC = () => {
    const trip = useSelector((store: StoreState) => store.trip);

    if (trip.isLoading) {
        return <Loading />;
    }
    let requiredActions: RequiredActions | undefined;
    requiredActions = trip.required_actions;

    if (!requiredActions) {
        return null;
    }

    const { contract_agreement: contractAgreement } = requiredActions;

    const newTermsData = contractAgreement?.new_terms;
    const houseRules = newTermsData?.house_rules ?? [];
    if (!houseRules) {
        return null;
    }

    const pm = trip.unit?.pms_data?.property_management;

    return (
        <div>
            <BackButton path="/reservation" />
            <h1 tabIndex={0} className="page-title no-print">
                {TranslationUtils.get('rental_terms')}
            </h1>

            <div id={'rental-instructions'} className={'rental-instructions'}>
                {TranslationUtils.get('pal_agreement_details_house_rules_text')}
            </div>
            <div id={'house-rules-container'} className={'house-rules-container'}>
                <div className={'house-rules-list'}>
                    {houseRules.map((rule: any) => (
                        <div className={'house-rules-list-el'}>
                            <span className={'rule-icon'}>{getHouseRuleIconByKey(rule.icon)}</span>
                            <span className={'rule-text body-regular'}>
                                {rule.text}
                                {rule.note && (
                                    <span className={'rule-note body-small'}>
                                        <IconAlertCircle className={'rule-note-icon'} />
                                        {rule.note}
                                    </span>
                                )}
                            </span>
                        </div>
                    ))}
                </div>
            </div>
            {newTermsData?.agreement_text && (
                <div id={'rental-confirmation-container'} className={'rental-confirmation'}>
                    <div className={'rental-conf-checkbox'}>
                        <div className={'check-input'}>
                            <IconCheckSquare />
                        </div>
                        <span
                            id={'check-conf-text'}
                            dangerouslySetInnerHTML={{
                                __html: newTermsData.agreement_text,
                            }}
                        />
                    </div>
                </div>
            )}
            {pm?.name && (pm?.email || pm?.phone) && (
                <QuestionPanel name={pm.name} email={pm.email ?? undefined} phoneNumber={pm.phone ?? undefined} />
            )}
        </div>
    );
};
